import React from "react";

export default function Updating() {
  return (
    <>
      <div className="d-flex justify-content-center align-items-center mt-5 pt-5 text3 text-success">
        Please Wait records is updating...
        <div className="spinner-grow" style={{ width: "40px", height: "40px" }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </>
  );
}
